"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIMPLE_TREE_VIEW_PLUGINS = void 0;
var _useTreeViewItems = require("../internals/plugins/useTreeViewItems");
var _useTreeViewExpansion = require("../internals/plugins/useTreeViewExpansion");
var _useTreeViewSelection = require("../internals/plugins/useTreeViewSelection");
var _useTreeViewFocus = require("../internals/plugins/useTreeViewFocus");
var _useTreeViewKeyboardNavigation = require("../internals/plugins/useTreeViewKeyboardNavigation");
var _useTreeViewJSXItems = require("../internals/plugins/useTreeViewJSXItems");
const SIMPLE_TREE_VIEW_PLUGINS = exports.SIMPLE_TREE_VIEW_PLUGINS = [_useTreeViewItems.useTreeViewItems, _useTreeViewExpansion.useTreeViewExpansion, _useTreeViewSelection.useTreeViewSelection, _useTreeViewFocus.useTreeViewFocus, _useTreeViewKeyboardNavigation.useTreeViewKeyboardNavigation, _useTreeViewJSXItems.useTreeViewJSXItems];

// We can't infer this type from the plugin, otherwise we would lose the generics.